import { render } from "./LogisSampleDataManage.vue?vue&type=template&id=6ef2d556"
import script from "./LogisSampleDataManage.vue?vue&type=script&lang=js"
export * from "./LogisSampleDataManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__